var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.58 2C15.59 2 18 4.48 18 7.5a5.53 5.53 0 0 1-1.847 4.133C17.856 12.56 19 14.407 19 16.5c0 3.002-2.352 5.5-5.333 5.5H8c-.679 0-1.289.003-1.78-.064-.454-.06-.918-.193-1.32-.517l-.168-.151c-.436-.437-.599-.97-.669-1.489C3.998 19.29 4 18.68 4 18V6c0-.679-.002-1.289.063-1.78.07-.519.233-1.051.67-1.488.436-.436.968-.599 1.488-.669C6.71 1.998 7.32 2 8 2zM6 13v5c0 .735.002 1.186.046 1.513.04.295.097.337.1.34l.06.037c.048.02.132.044.281.064.327.044.778.046 1.513.046h5.667C15.473 20 17 18.469 17 16.5S15.473 13 13.667 13zm2-9c-.735 0-1.186.002-1.513.046-.297.04-.338.098-.34.1s-.061.044-.101.341C6.002 4.814 6 5.265 6 6v5h6.58C14.451 11 16 9.45 16 7.5S14.452 4 12.58 4z",
    clipRule: "evenodd"
  })));
};
export default Svg24;